import React from 'react'
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { useAuthStore } from 'Store/Auth'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('รูปแบบอีเมลไม่ถูกต้อง')
    .min(3, 'ต้องมีอย่างน้อย 3 ตัวอักษร')
    .max(50, 'สูงสุด 50 ตัวอักษร')
    .required('กรุณากรอกอีเมล'),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const requestResetPassword = useAuthStore(state => state.requestResetPassword)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        requestResetPassword(values.email).then(({ success, data }) => {
          if (success) {
            setHasErrors(false)
            setLoading(false)
            setSubmitting(false)
          } else {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus(data)
          }
        })
      }, 1000)
    },
  })

  return (
    <div className='position-relative h-100 login-bg'>
      <div
        className='card rounded-3 w-xl-550px w-100 mx-auto position-absolute top-50'
        style={{ left: '50%', transform: 'translate(-50%, -50%)' }}>
        <div className='card-body p-10 p-xl-20'>
          <form
            className='form fv-plugins-bootstrap5 fv-plugins-framework'
            noValidate
            id='kt_login_password_reset_form'
            onSubmit={formik.handleSubmit}>
            <div className='text-center mb-10'>
              {/* begin::Title */}
              <h1 className='text-dark fw-bolder mb-3'>ลืมรหัสผ่าน ?</h1>
              {/* end::Title */}

              {/* begin::Link */}
              <div className='text-gray-500 fw-semibold fs-6'>
                กรอกอีเมลของคุณเพื่อรับลิงค์เปลี่ยนรหัสผ่าน
              </div>
              {/* end::Link */}
            </div>

            {/* begin::Title */}
            {hasErrors === true && (
              <div className='mb-lg-15 alert alert-danger'>
                <div className='alert-text font-weight-bold'>
                  ไม่พบอีเมลของคุณในระบบ กรุณาลองใหม่อีกครั้ง
                </div>
              </div>
            )}

            {hasErrors === false && (
              <div className='mb-10 bg-light-info p-8 rounded'>
                <div className='text-info'>ลิงค์เปลี่ยนรหัสผ่านถูกส่งไปยังอีเมลของคุณแล้ว</div>
              </div>
            )}
            {/* end::Title */}

            {/* begin::Form group */}
            <div className='fv-row mb-8'>
              <label className='form-label fw-bolder text-gray-900 fs-6'>อีเมล</label>
              <input
                type='email'
                placeholder=''
                autoComplete='off'
                {...formik.getFieldProps('email')}
                className={clsx(
                  'form-control bg-transparent',
                  { 'is-invalid': formik.touched.email && formik.errors.email },
                  {
                    'is-valid': formik.touched.email && !formik.errors.email,
                  }
                )}
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.email}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
              {(hasErrors === undefined || hasErrors === true) && (
                <React.Fragment>
                  <button
                    type='submit'
                    id='kt_password_reset_submit'
                    className='btn btn-primary me-4'
                    disabled={formik.isSubmitting}>
                    <span className='indicator-label'>ยืนยัน</span>
                    {loading && (
                      <span className='indicator-progress'>
                        กำลังร้องขอ...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  <Link to='/auth/login'>
                    <button
                      type='button'
                      id='kt_login_password_reset_form_cancel_button'
                      className='btn btn-light'
                      disabled={formik.isSubmitting || !formik.isValid}>
                      ยกเลิก
                    </button>
                  </Link>{' '}
                </React.Fragment>
              )}
              {hasErrors === false && (
                <React.Fragment>
                  <Link to='/auth/login'>
                    <button
                      type='submit'
                      id='kt_password_reset_submit'
                      className='btn btn-primary me-4'>
                      <span className='indicator-label'>ตกลง</span>
                    </button>
                  </Link>
                </React.Fragment>
              )}
            </div>
            {/* end::Form group */}
          </form>
        </div>
      </div>
    </div>
  )
}
